(function () {
  'use strict';

  function homepageRegistrationModalController($scope, $log, $timeout, $rootScope, $uibModalInstance,
    $location, $window, $cookies, $filter,
    entityType, registrationDataService, notifyService) {

    $scope.model = {
      EntityType: entityType,
      ReferralCampaign: $cookies.get('referralCampaign'),
      ReferralToken: $cookies.get('referralToken')
    };

    $scope.errors = [];
    $scope.submit = function() {
      $scope.hideButtons = true;

      if ($scope.model.AccountType === "PlatformEntity" && !$scope.model.EditableEntityType) {
        $scope.errors = ["EntityType is missing"];
        return;
      }

      registrationDataService.registerEntity($scope.model).then(
        function (result) {
          if (result.Errors && result.Errors.length > 0) {
            $scope.errors = result.Errors;
            $scope.hideButtons = false;
          }
          else {
            $scope.hideButtons = true;
            $scope.errors = [];
            notifyService.notify('Your account has been created. You are being logged in.');

            // remove cookies
            if ($cookies.get('referralCampaign')) {
              $cookies.remove('referralCampaign');
            }

            if ($cookies.get('referralToken')) {
              $cookies.remove('referralToken');
            }

            $timeout(function () {
              $('#submitAfterRegisteringForm').submit();
            }, 2000);
          }
        }
      )
    }

    $scope.canCheckBox = false;

    $scope.close = function () {
      $uibModalInstance.close({
        accepted: $scope.model.HasAcceptedTermsOfService,
        clicked: true
      });
    };

    $scope.cancel = function () {
      $uibModalInstance.close();
    };

    $timeout(function () {
      var iframe = document.getElementById("termsOfService").contentWindow;
      $(iframe).scroll(function () {
          if ($(iframe).scrollTop()*1.0 / $(iframe.document).innerHeight() > 0.9) {
              $scope.canCheckBox = true;
              $scope.$apply();
          }
      });
    }, 1000);
  }

  homepageRegistrationModalController.$inject = ['$scope', '$log', '$timeout', '$rootScope', '$uibModalInstance',
    '$location', '$window', '$cookies', '$filter',
    'entityType', 'registrationDataService', 'notifyService'];

  angular.module('ecap.registration').controller('homepageRegistrationModalController', homepageRegistrationModalController);
})();